import script from "./ConfigBillingSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigBillingSection.vue?vue&type=script&setup=true&lang=js"

import "./ConfigBillingSection.vue?vue&type=style&index=0&id=c64e5e66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64e5e66"]])

export default __exports__